import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Jeff Anders
 * id D10BDD69-ACE3-4540-B224-EF52A45B1E99
 * name upload-box-outline
 * version: 7.4.47
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/upload-box-outline.svg
 * tags
 */
export const UploadBoxOutlineIcon = createSvgIcon(<><path d="M8 17V15H16V17H8M16 11L12 7L8 11H10.5V14H13.5V11H16M5 3H19C20.11 3 21 3.9 21 5V19C21 20.11 20.11 21 19 21H5C3.9 21 3 20.11 3 19V5C3 3.9 3.9 3 5 3M5 5V19H19V5H5Z" /></>, 'UploadBoxOutlineIcon');
export default UploadBoxOutlineIcon